import {match} from 'ts-pattern';

import {VehicleFinancingTemplateStatus} from '@dms/features/vehicle-financing-template';
import i18n from '@dms/i18n';

export function getTemplateStatusLabel(status: VehicleFinancingTemplateStatus) {
  return match(status)
    .with('PLANNED', () => i18n.t('entity.vehicleFinancingTemplate.status.planned'))
    .with('ACTIVE', () => i18n.t('entity.vehicleFinancingTemplate.status.active'))
    .with('EXPIRED', () => i18n.t('entity.vehicleFinancingTemplate.status.expired'))
    .with('ARCHIVED', () => i18n.t('entity.vehicleFinancingTemplate.status.archived'))
    .exhaustive();
}
